import { useRef } from 'react'
import { useSpiffClient } from '../hooks/useSpiffClient'
import Canvas from './Canvas/Canvas'
import { SelectionPanel } from './SelectionPanel/SelectionPanel'
import { Spinner } from './Spinner/Spinner'
import './style.css' // Tailwind CSS

export const NecklaceBuilder = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  const spiffState = useSpiffClient(canvasRef)

  return (
    <div className="relative md:static -mx-5">
      <div className="flex flex-col md:flex-row w-full justify-between border-t border-primary">
        <Canvas canvasRef={canvasRef} spiffState={spiffState} />
        {spiffState?.bundle ? (
          <SelectionPanel spiffState={spiffState} canvasRef={canvasRef} />
        ) : (
          <div className="relative bg-white md:min-w-[400px] lg:min-w-[493px] w-full md:w-[35%] aspect-[1/1] md:aspect-[initial]">
            <Spinner />
          </div>
        )}
      </div>
    </div>
  )
}
